var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("span", { staticClass: "btn", on: { click: _vm.openLoginModal } }, [
        _vm._v("\n       " + _vm._s(_vm.lang.magazine.button) + "\n    ")
      ]),
      _vm._v(" "),
      _c("modal", {
        ref: "magazine-modal",
        attrs: {
          name: "magazine-modal",
          "extra-class": "full-modal animated fadeInUpBig"
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function(props) {
              return [
                _c("div", { ref: "rrrr" }),
                _vm._v(" "),
                _c("flipbook", {
                  ref: "flipbook",
                  staticClass: "flipbook",
                  attrs: { pages: [""].concat(_vm.pages) },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(flipbook) {
                          return [
                            _c("div", { staticClass: "ico-flip" }, [
                              _c(
                                "button",
                                { on: { click: flipbook.flipLeft } },
                                [
                                  _c("masked-image", {
                                    attrs: {
                                      src: "/img/icons/ico_arrow-left.svg"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                { on: { click: flipbook.flipRight } },
                                [
                                  _c("masked-image", {
                                    attrs: {
                                      src: "/img/icons/ico_arrow-right.svg"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                { on: { click: flipbook.zoomIn } },
                                [
                                  _c("masked-image", {
                                    attrs: { src: "/img/icons/ico_zoom-in.svg" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                { on: { click: flipbook.zoomOut } },
                                [
                                  _c("masked-image", {
                                    attrs: {
                                      src: "/img/icons/ico_zoom-out.svg"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(
                                "\n\n                " +
                                  _vm._s(flipbook.page) +
                                  " / " +
                                  _vm._s(flipbook.numPages) +
                                  "\n            "
                              )
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }